/**
 * "Take me there" (DESIGN_PROMOTION §4.6): the card under a where-answer carries `teleport:<entry id>` as its
 * option's value (backend/brain/portal-card.ts).
 */
export const TELEPORT_VALUE_PREFIX = 'teleport:';

/** The settings-map entry a card option takes the user to, or null when the value is not a teleport. */
export function teleportTarget(value: string): string | null {
  if (!value.startsWith(TELEPORT_VALUE_PREFIX)) return null;
  const entryId = value.slice(TELEPORT_VALUE_PREFIX.length).trim();
  return entryId === '' ? null : entryId;
}
